import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { InputBaseContainer, InputSelectWithLabel } from '../../../../../molecules';
import { labels } from '../constants';
import { RootState } from '../../../../../redux/root';

const ActivityTitle = ({ control, errors, setValue }) => {
  const { titlesData, selectedInspection, disabledGlobalSearch } = useSelector((s: RootState) => s.inspections);
  useEffect(() => {
      const activityTitle = titlesData.find(title => title.id === selectedInspection.title);
      setValue('activityTitle', activityTitle);
  }, [titlesData]);
  return (
    <InputBaseContainer>
      <Controller
        name="activityTitle"
        defaultValue=""
        control={control}
        // A string message (not `required: true`) — InputSelectWithLabel renders
        // error.message, so a boolean rule shows an empty error.
        rules={{ required: `${labels.activityTitle} is required` }}
        render={props => (
          <InputSelectWithLabel
            showInRow
            placeholder=""
            menuPlacement="bottom"
            options={titlesData}
            isLoading={false}
            isDisabled={disabledGlobalSearch}
            isRequired
            label={labels.activityTitle}
            error={errors.activityTitle}
            getOptionValue={(item: any) => item.id || Math.random()}
            getOptionLabel={(item: any) => item.name}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        )}
      />
    </InputBaseContainer>
  );
};

export default ActivityTitle;
